import { useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { createMessage } from '../../actions/messages'
import { getPedidoActivo } from '../../actions/pedidos'
import { acceptLines, rejectLines } from '../../actions/restos'

import ReactModal from 'react-modal'
import Utils from '../../helpers/Utils'

ReactModal.setAppElement('#root')

const LineasPendientesModal = ({
  pendingLines,
  isOpen,
  onRequestClose,
  getPendingLines,
  setPendingLines,
}) => {
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(false)
  const [selectedLines, setSelectedLines] = useState([])
  const pedido_activo = useSelector(state => state.pedidos.id_pedido_seleccionado)
  const pedido = useSelector(state => state.pedidos.pedido)
  const allLinesIn = useMemo(() => {
    let equalsCount = 0
    if (selectedLines.length === 0) return false
    pendingLines.forEach(pending => {
      selectedLines.forEach(selected => {
        const equals = Utils.strigifyObjectsEqual(pending, selected)
        console.log(equals)
        if (equals) equalsCount++
      })
    })
    console.log({ pendingLines, selectedLines, equalsCount })
    return equalsCount === pendingLines?.length
  }, [selectedLines, pendingLines])

  const endRemoval = () => {
    setPendingLines(
      pendingLines.filter(
        line1 =>
          !selectedLines.some(
            line2 =>
              line2.numero_linea === line1.numero_linea &&
              line2.numero_pedido === line1.numero_pedido &&
              line2.numero_serie === line1.numero_serie,
          ),
      ),
    )
  }

  const toggleLine = (line, selected) => {
    if (!selected) {
      const lines = selectedLines.filter(currentLine => {
        const lineas_iguales = currentLine.numero_linea === line.numero_linea
        const pedidos_iguales = currentLine.numero_pedido === line.numero_pedido
        const series_iguales = currentLine.numero_serie === line.numero_serie

        return !(lineas_iguales && pedidos_iguales && series_iguales)
      })
      return setSelectedLines(lines)
    }
    const lines = [...selectedLines]
    lines.push(line)
    setSelectedLines(lines)
  }

  const rechazarLineas = async () => {
    try {
      setIsLoading(true)
      await rejectLines()
      setIsLoading(false)
      dispatch(createMessage('Se han rechazado las lineas de pedido', 'success'))
      endRemoval()
      setSelectedLines([])
      onRequestClose()
    } catch (error) {
      setIsLoading(false)
      dispatch(createMessage('No se ha podido realizar la operación', 'error'))
    }
  }

  const aceptarLineas = async () => {
    try {
      setIsLoading(true)
      await acceptLines(selectedLines)
      dispatch(createMessage('Se han agregado los articulos al pedido', 'success'))
      dispatch(getPedidoActivo('', 'S', pedido_activo || pedido.id_pedido))
      await getPendingLines()
      endRemoval()
      setSelectedLines([])
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      dispatch(createMessage('No se ha podido realizar la operación', 'error'))
    }
  }

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={() => onRequestClose()}
      style={{
        content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
          maxHeight: '80vh',
          maxWidth: '80vw',
          textAlign: 'center',
          resize: 'both',
          overflow: 'hidden',
        },
        overlay: {
          zIndex: '9999',
        },
      }}>
      <div className='pending-lines'>
        {isLoading ? (
          <div className='processing'>
            <span className='processing-text'>Procesando</span>
          </div>
        ) : (
          <></>
        )}
        <div>
          <h4>Existen articulos que no te han sido entregados</h4>

          <div className='line-data-grid'>
            <input
              className='point'
              type='checkbox'
              id={`cbox-`}
              checked={allLinesIn}
              onChange={event => {
                if (allLinesIn) setSelectedLines([])
                else setSelectedLines(pendingLines)
              }}
            />
            <div>
              <b>Articulo</b>
            </div>
            {'   '}
            <div style={{ textAlign: 'right' }}>
              <b>Cantidad</b>
            </div>
            {'   '}
            <div style={{ textAlign: 'right' }}>
              <b>Importe</b>
            </div>

            <span
              style={{ display: 'none' }}
              className='separator'></span>
            {pendingLines.map((linea, i) => {
              return (
                <ArticuloPendiente
                  linea={linea}
                  key={i}
                  index={i}
                  selectedLines={selectedLines}
                  toggleLine={toggleLine}
                />
              )
            })}
          </div>
        </div>
        <div className='foot'>
          <div className='buttons'>
            <button
              disabled={isLoading || selectedLines.length > 0}
              onClick={rechazarLineas}
              className='btn mt-3 btn-danger'>
              Rechazar
            </button>
            <button
              disabled={isLoading || selectedLines.length === 0}
              onClick={aceptarLineas}
              className='btn mt-3 btn-success'>
              Añadir al pedido
            </button>
          </div>
          <p>Si pulsas en rechazar esta ventana no volverá a aparecer para estos artículos</p>
        </div>
      </div>
    </ReactModal>
  )
}

const ArticuloPendiente = ({ linea: current_line, toggleLine, index, selectedLines }) => {
  const [included, setIncluded] = useState(false)
  const checked = useMemo(() => {
    const contained = selectedLines.some(selected =>
      Utils.strigifyObjectsEqual(current_line, selected),
    )

    console.log({ contained, selectedLines })

    // return selectedLines.includes(current_line)
    return contained
  }, [included, selectedLines?.length])

  return (
    <>
      <input
        className='point'
        type='checkbox'
        id={`cbox-${index}`}
        onClick={_ => {
          toggleLine(current_line, !included)
          setIncluded(!included)
        }}
        checked={checked}
      />
      <div
        className='point'
        onClick={_ => {
          document.querySelector(`#cbox-${index}`).click()
        }}>
        {current_line.descripcion_articulo}
      </div>
      {'   '}
      <div style={{ textAlign: 'right' }}>
        {current_line.cantidad_pedida - current_line.unidades_servidas}{' '}
        {current_line.presentacion_pedido}
      </div>
      {'   '}
      <div style={{ textAlign: 'right' }}>
        <span className='price-tag'>
          {(
            current_line.precio_presentacion *
            (current_line.cantidad_pedida - current_line.unidades_servidas)
          ).toFixed(2)}
          €
        </span>
      </div>
      <span className='separator'></span>
    </>
  )
}

export default LineasPendientesModal
